export function getMyRequestEndpoint(): string {
    return '/my-request';
}
